import { config } from '@utility/config';
import { loadStripe } from '@stripe/stripe-js';
let stripePromise;
export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(config.stripePublicKey);
  }
  return stripePromise;
};
